import Vue from "vue";
import App from "./App.vue";
import { createRouter } from "./router";
import { createStore } from "./store";

import { sync } from "vuex-router-sync";
import global_ from "./api/global";
import { format } from "timeago.js";
//import VueSocketio from 'vue-socket.io'
import Moment from 'moment'
Vue.prototype.global = global_;
Vue.use(global_);

import axios from "axios";

const TARGET_NODE = process.env.BUILD_TARGET === "node";

if(!TARGET_NODE){
  import("@assets/less/stylePublic.less")
}


//关闭生产模式下给出的提示
Vue.config.productionTip = false;

// for using vant components
import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);

// // // 图片查看器
// import Viewer from "v-viewer";
// import "viewerjs/dist/viewer.css";
// Vue.use(Viewer);
// Viewer.setDefaults({
//   title: 0
// });

// // 视频播放器
// import VideoPlayer from 'vue-video-player'
// import('video.js/dist/video-js.css')
// import('vue-video-player/src/custom-theme.css')
// Vue.use(VideoPlayer)

// element-ui
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI, { size: "small" });
ElementUI.Dialog.props.lockScroll.default = false // 全局dialog组件出现时将 body 滚动锁定取消
ElementUI.Dialog.props.closeOnClickModal.default = false // 全局dialog组件取消点击 modal 时关闭
ElementUI.Dialog.props.closeOnPressEscape.default = false // 全局dialog组件取消 Esc 关闭modal

import DiaLogin from '@@/pub/dialogin/dialogin.js'
// Vue.use(new VueSocketio({
//   debug: true,
//   connection:  global_.imUrl
// }))
// const VueSocketio =() => import('vue-socket.io')
// VueSocketio().then(res =>{
//   Vue.use(new res.default({
//     debug: false,
//     connection:  global_.imUrl
//   }))
// })


const QRCodeBak = () => import('qrcodejs2')
QRCodeBak().then(res =>{
  Vue.prototype.QRCode = res.default
})
Vue.use(DiaLogin)

// global loading
Vue.prototype.$loading = isLoading => {
  if (isLoading) {
    Vue.prototype.$toast.loading({
      mask: true,
      message: "加载中...",
      overlayStyle: {
        backgroundColor: "rgba(0, 0, 0, 0.1)"
      },
      duration: 0
    });
  } else {
    Vue.prototype.$toast.clear();
  }
};

export function createApp() {
  const router = createRouter();
  const store = createStore();
  // sync the router with the vuex store.
  // this registers `store.state.route`

  // 导航守卫-start
  router.beforeEach((to, from, next) => {
    let isLogin = global_.isLogin;
    let locHost = "http://www.renrendonghua.com"
    let href = locHost+to.path

    let callback=href.substring(href.indexOf("callback"),href.length).replace("callback=","");
    callback=decodeURIComponent(callback);

    let url =
      "/api/checkLogin?time=" +
      new Date().getMilliseconds();
    axios.get(url).then(function(result) {
      // console.log("beforeEach===============checkLogin=======",result)
      if (result.status == 200 && result.data.isLogin) {
        global_.setUserModel(result.data.casFastUserModel);
        global_.setIsLogin(true);

        if (
          to.path != "/setname" &&
          global_.userModel.name != null &&
          result.data.casFastUserModel.name ==
            result.data.casFastUserModel.userName
        ) {
          window.location.href = "http://www.renrendonghua.com/setname?callback="+callback;
        } else {
          let interestsUrl =
            "/rrbi/interests/userInterests?userId=" +
            result.data.casFastUserModel.id +
            "&time=" +
            new Date().getMilliseconds();
          axios.get(interestsUrl).then(function(interResult) {
            // console.log(
            //     "interResult.data.response",
            //     interResult.data.response.length
            // );
            if (
              to.path != "/setname" &&
              interResult.data.response.length == 0 &&
              to.path != "/selecttype"
            ) {
              window.location.href = "http://www.renrendonghua.com/selecttype?callback="+callback;
            } else {
              next();
            }
          });
        }
      } else {
        global_.setUserModel(null);
        global_.setIsLogin(false);
        next();
      }
    });

    next();
  });
  router.beforeResolve((to, from, next) => {
    let isLogin = global_.isLogin;
    next();
  });
  sync(store, router);
  const app = new Vue({
    router,
    store,
    render: h => h(App),
  });
  return { app, router, store };
}

//定义全局的过滤器 "formatTime":改变时间为几周前
Vue.filter("formatTime", function(dateStr) {
  // console.info("@@@@@@@@@@@@@@@@@@@@@@@@@");
  // console.info(dateStr);
  var m=Moment(dateStr).utc();
  // console.info(m.format());
  m.add(-7, 'minutes');
  // console.info(m.format());
  // console.info("##########################");
  return format(m.format(), "zh_CN");
});

Vue.prototype.toTop = function() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
};
Vue.prototype.toChart = function(userId) {
  window.open("http://" + window.location.host + "/chatroom?id=" + userId);
};

// promise.finally Polyfill
if (!Promise.prototype.finally) {
  Promise.prototype.finally = function(callback) {
    let P = this.constructor;
    return this.then(
      value => P.resolve(callback()).then(() => value),
      reason =>
        P.resolve(callback()).then(() => {
          throw reason;
        })
    );
  };
}
